export const FACEBOOK_URL = 'https://www.facebook.com/elementarycreativeofficial/'
export const INSTAGRAM_URL = 'https://www.instagram.com/elementarycreative/'
export const TIKTOK_URL = 'https://www.tiktok.com/@elementarycreative'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/elementary-creative/'
export const CALENDLY_URL = 'https://calendly.com/elementarycreative/30min'

export const SOCIAL_LINKS = [
  { label: 'Instagram', href: INSTAGRAM_URL },
  { label: 'Facebook', href: FACEBOOK_URL },
  { label: 'LinkedIn', href: LINKEDIN_URL },
  { label: 'TikTok', href: TIKTOK_URL },
] as const
